import {
  Component,
  ViewChild,
  ViewChildren,
  QueryList,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  inject,
  ElementRef,
  NgZone,
  AfterViewInit,
} from '@angular/core'
import { animate, state, style, transition, trigger } from '@angular/animations'
import { MatSort, MatSortHeader, MatSortModule } from '@angular/material/sort'
import {
  MatTableDataSource,
  MatTable,
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
  MatHeaderRowDef,
  MatHeaderRow,
  MatRowDef,
  MatRow,
  MatTableModule,
} from '@angular/material/table'
import {
  Comment,
  TRACKING_DETAILS_COLUMNS,
  TRACKING_VIEW_COLUMNS,
  TrackingData,
  TrackingDetailsLayerData,
  TrackingSelectors,
  TrackingViewsData,
} from '../tracking.model'
import { SortTableColumnDef } from '@shared/sort-table/sort-table.model'
import { BasicControl } from 'src/app/management-information/model/management-information.model'
import { CommonModule, NgStyle } from '@angular/common'
import { MatIcon, MatIconModule } from '@angular/material/icon'
import { MatFormField, MatFormFieldModule } from '@angular/material/form-field'
import { MatInput, MatInputModule } from '@angular/material/input'
import { MatMenuModule } from '@angular/material/menu'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatSelectModule } from '@angular/material/select'
import { ProgressCellComponent } from '../progress-cell/progress-cell.component'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MAT_DATE_LOCALE, MatNativeDateModule, MatOptionModule } from '@angular/material/core'
import { MatTooltip } from '@angular/material/tooltip'
import { User } from 'src/app/api/model/backend.model'
import { MatDialog } from '@angular/material/dialog'
import { CommentDialogComponent } from '../comment-dialog/comment-dialog.component'
import { MatProgressSpinner, MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { OverlayContainer } from '@angular/cdk/overlay'
import { TemplateRef, ViewContainerRef } from '@angular/core'
import { Overlay, OverlayRef } from '@angular/cdk/overlay'
import { TemplatePortal } from '@angular/cdk/portal'
import { ExportCommentsService } from '../export-comments.service'
import { ExportTrackingDatesService } from '../export-tracking-dates.service'
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator'
import { MatSelect } from '@angular/material/select'
import { fromEvent, Subscription } from 'rxjs'
import { NavigationStart, Router } from '@angular/router'

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-tracking-views',
  templateUrl: './tracking-views.component.html',
  styleUrl: './tracking-views.component.scss',
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  providers: [{ provide: MAT_DATE_LOCALE, useValue: 'en-GB' }],
  imports: [
    MatTable,
    MatSort,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatSortHeader,
    MatCellDef,
    MatCell,
    MatIcon,
    MatFormField,
    MatInput,
    NgStyle,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    MatMenuModule,
    MatIconModule,
    MatProgressSpinner,
    MatProgressSpinnerModule,
    CommonModule,
    FormsModule,
    MatTableModule,
    MatSortModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    ProgressCellComponent,
    MatDatepickerModule,
    MatNativeDateModule,
    ReactiveFormsModule,
    MatOptionModule,
    MatTooltip,
    MatPaginatorModule,
    MatPaginator,
  ],
})
export class TrackingViewsComponent implements OnInit, OnChanges, AfterViewInit {
  name = 'Tracking Module'

  @ViewChild('outerSort') set matSort(ms: MatSort | undefined) {
    this.sort = ms ?? undefined
    if (this.dataSource && this.sort) {
      this.dataSource.sort = this.sort
    }
  }
  private sort?: MatSort
  @ViewChildren('innerSort') innerSort?: QueryList<MatSort>
  @ViewChildren('innerTables') innerTables?: QueryList<MatTable<TrackingDetailsLayerData>>
  @ViewChild('outerTable') outerTable?: MatTable<TrackingData>
  @ViewChild('globalPicker') globalPicker: any
  @ViewChild('calendarTemplate') calendarTemplate?: TemplateRef<any>
  @ViewChild(MatPaginator) paginator?: MatPaginator
  @ViewChildren(MatHeaderCell, { read: ElementRef })
  headerCellEls!: QueryList<ElementRef<HTMLElement>>

  @Input() trackingData: TrackingData[] | null = []
  @Input() trackingMyViewsData: TrackingViewsData[] | null = []
  @Input() selectors: TrackingSelectors | null = null
  @Input() isLoading: boolean = false
  @Input() isDetailsLoading: boolean = false
  @Input() inceptionInterval: BasicControl | null = null
  @Input() usersResponse: User[] = []
  @Input() currentviewType: string = ''

  @Output() filtersChanged = new EventEmitter<{
    filters: Record<string, string[]>
  }>()
  @Output() fetchTrackingDetails = new EventEmitter<number>()
  @Output() inceptionDateChanged = new EventEmitter<{
    minInceptionDate: string
    maxInceptionDate: string
  }>()
  @Output() updateColumnValue = new EventEmitter<{
    opportunityId: string | number
    category: string
    newValue: any
    dateTime?: string
    viewType: string
  }>()
  @Output() updateComment = new EventEmitter<{
    opportunityId: string | number
    category: string
    comment: string
    viewType: string
  }>()
  @Output() updateUserValue = new EventEmitter<{
    opportunityId: string | number
    email_id: string[]
    OpportunityTeamRoles: string
    viewType: string
  }>()
  @Output() saveTrackingPreferences = new EventEmitter()
  @Output() setTrackingPreferences = new EventEmitter<{ id: number }>()

  currentDate: Date | null = null
  dataSource?: MatTableDataSource<TrackingViewsData>
  trackingTableData: TrackingViewsData[] = []
  columnDefs: SortTableColumnDef[] = TRACKING_VIEW_COLUMNS
  colIds: string[] = []
  innerColumnDefs: SortTableColumnDef[] = TRACKING_DETAILS_COLUMNS
  innerColIds: string[] = []
  filtersData: Record<string, string[]> = {}
  filteredtrackingData: TrackingViewsData[] | null = []
  exportTrackingData: TrackingViewsData[] | null = []

  private _colWidthById = new Map<string, number>()
  private _leftById = new Map<string, number>()
  private cd = inject(ChangeDetectorRef)
  private dialog = inject(MatDialog)
  private overlayRef: OverlayRef | null = null
  private activeCalendarContext: {
    element: any
    column: any
    ref: any
    selectedDate: Date
  } | null = null
  private readonly PROGRESS_COLUMNS = [
    'clientInstructions',
    'submission',
    'draftContract',
    'quote',
    'FOTS',
    'signings',
    'finalContract',
  ]
  private searchSub?: Subscription
  private readonly COMPLETION_MAP: Record<string, string[]> = {
    clientInstructions: ['n/a', 'received'],
    submission: ['n/a', 'sent to reinsurers'],
    draftContract: ['client signoff', 'n/a'],
    quote: ['n/a', 'sent to client'],
    FOTS: ['sent to reinsurers'],
    signings: ['confirmed with reinsurers'],
    finalContract: ['signed'],
  }
  private completedMap: Record<string, Set<string>> = {}

  pinnedColumns: Set<string> = new Set(['clientName', 'programName', 'placementProgress'])
  pinEnabledColumns: string[] = ['clientName', 'programName', 'placementProgress']
  boundCalendarSelect!: (date: Date) => void

  @ViewChild('multiSelect') multiSelect!: MatSelect

  filteredOptions: Record<string, any[]> = {}
  constructor(
    private overlay: Overlay,
    private viewContainerRef: ViewContainerRef,
    private exportComments: ExportCommentsService,
    private exportService: ExportTrackingDatesService,
    private ngZone: NgZone,
    private overlayContainer: OverlayContainer,
    private router: Router,
  ) {
    this.boundCalendarSelect = this.calendarDateSelected.bind(this)
  }

  ngOnInit(): void {
    this.filteredtrackingData = this.trackingTableData
    // Only clear sort when user navigates OUTSIDE of tracking module
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        const goingToTracking = event.url.includes('/tracking')
        if (!goingToTracking) {
          localStorage.removeItem('trackingSortState')
        }
      }
    })
  }
  ngAfterViewInit(): void {
    if (this.dataSource && this.paginator) {
      this.dataSource.paginator = this.paginator
    }
    if (this.sort) {
      this.dataSource!.sort = this.sort

      //  Restore sort state here
      const savedSort = localStorage.getItem('trackingSortState')
      if (savedSort) {
        const { active, direction } = JSON.parse(savedSort)
        if (this.colIds.includes(active)) {
          this.sort.active = active
          this.sort.direction = direction as 'asc' | 'desc' | ''
          this.dataSource!.sort = this.sort
        }
      }

      //  Save sort changes
      this.sort.sortChange.subscribe(() => {
        const sortState = {
          active: this.sort?.active || '',
          direction: this.sort?.direction || '',
        }
        localStorage.setItem('trackingSortState', JSON.stringify(sortState))
      })
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    // columnDefs only depends on usersResponse and currentviewType — skip the rebuild on
    // every data/selector change, which previously caused a full column re-diff each time.
    if (changes['usersResponse'] || changes['currentviewType']) {
      let visibleColumns = TRACKING_VIEW_COLUMNS
      if (this.currentviewType !== 'client view') {
        visibleColumns = TRACKING_VIEW_COLUMNS.filter((col) => col.id !== 'businessUnit')
      }
      this.columnDefs = visibleColumns.map((col) => {
        if (['accountExecutive', 'support', 'analytics'].includes(String(col.id))) {
          return {
            ...col,
            references:
              this.usersResponse?.map((user: any) => ({
                value: user.email_id,
                viewValue: `${user.first_name} ${user.last_name}`,
              })) ?? [],
          }
        }
        return col
      })
      this.colIds = this.columnDefs.map((c) => c.id as string)
    }

    // Skip the data pipeline entirely when only unrelated inputs changed (e.g. isLoading).
    if (!changes['trackingMyViewsData'] && !changes['selectors'] && !changes['inceptionInterval']) {
      if (changes['usersResponse'] || changes['currentviewType']) {
        this.cd.detectChanges()
      }
      return
    }

    this.trackingTableData = []
    if (!this.trackingMyViewsData) {
      return
    }
    this.filteredtrackingData = [...this.trackingMyViewsData]
    let rawData = [...this.trackingMyViewsData]
    rawData = rawData.map((item) => {
      const PROGRESS_COLUMNS = [
        'clientInstructions',
        'submission',
        'draftContract',
        'quote',
        'FOTS',
        'signings',
        'finalContract',
      ]

      const total = PROGRESS_COLUMNS.length
      const completedCount = PROGRESS_COLUMNS.filter((colId) =>
        this.isColumnComplete(colId, item),
      ).length

      let percentage = Math.round(((completedCount / total) * 100) / 5) * 5
      return { ...item, placementProgress: { value: percentage } }
    })

    if (this.selectors) {
      if (this.selectors && this.selectors.complete.selectedValues.length > 0) {
        const filterValues = this.selectors.complete.selectedValues.map((v) =>
          v.toString().trim().toLowerCase(),
        )

        this.filteredtrackingData = rawData.filter((item) => {
          const progressVal = item.placementProgress?.value ?? 0
          const isComplete = progressVal === 100

          if (filterValues.includes('yes') || filterValues.includes('complete')) {
            return isComplete
          }
          if (filterValues.includes('no') || filterValues.includes('incomplete')) {
            return !isComplete
          }
          return true
        })
      }
      if (this.selectors.clientName?.selectedValues?.length > 0) {
        this.filteredtrackingData = this.filteredtrackingData.filter((item) =>
          this.selectors?.clientName?.selectedValues.includes(item.client),
        )
      }
      if (this.selectors?.businessUnit?.selectedValues?.length > 0) {
        this.filteredtrackingData = this.filteredtrackingData.filter((item) =>
          this.selectors?.businessUnit?.selectedValues.includes(item.businessUnit),
        )
      }
      if (this.selectors?.year?.selectedValues?.length > 0) {
        this.filteredtrackingData = this.filteredtrackingData.filter((item) =>
          this.selectors?.year?.selectedValues.includes(item.year),
        )
      }
    }
    if (this.inceptionInterval?.minValue && this.inceptionInterval?.maxValue) {
      const minDate = this.toCalendarDate(this.inceptionInterval.minValue)
      const maxDate = this.toCalendarDate(this.inceptionInterval.maxValue)
      this.filteredtrackingData = this.filteredtrackingData.filter((data) => {
        const inception = this.toCalendarDate(data.inceptionDate)
        if (!inception || !minDate || !maxDate) {
          return true
        }
        return inception >= minDate && inception <= maxDate
      })
    }
    this.exportTrackingData = [...this.filteredtrackingData]
    this.trackingTableData = this.mapApiResponseToTableData(this.filteredtrackingData)

    // Update rows in-place on the existing data source to avoid tearing down and
    // rebuilding the Material table (sticky column reflow, sort/paginator reconnect)
    // on every input change.
    if (!this.dataSource) {
      this.dataSource = new MatTableDataSource(this.trackingTableData)
      this.dataSource.sortingDataAccessor = (item: any, property: string): any => {
        switch (property) {
          case 'clientName':
            return item.clientName?.value?.toLowerCase() || item.client?.toLowerCase() || ''

          case 'inceptionDate':
            const dateStr = item.inceptionDate?.value || item.inceptionDate || ''
            const parsedDate = new Date(dateStr)
            return parsedDate instanceof Date && !isNaN(parsedDate.getTime())
              ? parsedDate.getTime()
              : 0

          default:
            return 0
        }
      }
      if (this.paginator) this.dataSource.paginator = this.paginator
      if (this.sort) this.dataSource.sort = this.sort
    } else {
      this.dataSource.data = this.trackingTableData
    }

    //  Restore saved sort if available
    if (!this.sort) {
      setTimeout(() => this.restoreSortState(), 100)
    } else {
      this.restoreSortState()
    }

    this.cd.detectChanges()

    // Recompute the sticky styles once layout is stable.
    setTimeout(() => this.outerTable?.updateStickyColumnStyles(), 0)
  }

  private restoreSortState(): void {
    const savedSort = localStorage.getItem('trackingSortState')
    if (savedSort && this.sort) {
      const { active, direction } = JSON.parse(savedSort)
      if (this.colIds.includes(active)) {
        this.sort.active = active
        this.sort.direction = direction as 'asc' | 'desc' | ''
        this.dataSource!.sort = this.sort
      }
    }
  }

  // Normalize an inception value to a local calendar date (time stripped) so the
  // date-only interval bounds ("yyyy-mm-dd", parsed as UTC by `new Date`) and the
  // API inception values ("yyyy-mm-ddTHH:mm:ss", parsed as local) compare
  // consistently and boundary rows are not dropped in UTC+ timezones.
  private toCalendarDate(value: string | null): Date | null {
    if (!value) {
      return null
    }
    const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value)
    if (match) {
      return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]))
    }
    const parsed = new Date(value)
    return isNaN(parsed.getTime())
      ? null
      : new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate())
  }

  filtersChange(props: { filters: Record<string, string[]>; isSet: boolean }): void {
    this.filtersData = props.filters
    if (props.isSet) {
      this.filtersChanged.emit(props)
    }
  }

  exportToExcel(): void {
    const dataToExport = this.exportTrackingData || []
    this.exportService.exportTrackingData(dataToExport)
  }

  downloadComments(element: any): void {
    this.exportComments.downloadProgramComments(element)
  }
  toggleRow(element: TrackingData): void {
    this.fetchTrackingDetails.emit(element.programId)
  }
  applyFilter(filterValue: string): void {
    this.innerTables?.forEach(
      (table) =>
        ((table.dataSource as MatTableDataSource<TrackingDetailsLayerData>).filter = filterValue
          .trim()
          .toLowerCase()),
    )
  }
  getCellStyle(col: SortTableColumnDef): Record<string, string> {
    let style: Record<string, string> = {}
    if (col?.width != null) {
      style['width'] = col.width
    }
    return style
  }

  currentCell: { element: any; column: string } | null = null

  setCurrentCell(element: any, column: string) {
    this.currentCell = { element, column }
  }
  isSortable(columnId: string): boolean {
    return ['clientName', 'inceptionDate'].includes(columnId)
  }
  onMultiCellDropdownChange(element: any, column: any, newValue: string[]): void {
    const opportunityId = element.opportunityId ?? element.programId ?? null
    const columnId = column.id
    // Ensure object exists
    if (!element[columnId]) {
      element[columnId] = { value: [], emails: [] }
    }

    // Update local model
    element[columnId].value = newValue
    element[columnId].emails = newValue

    this.updateUserValue.emit({
      opportunityId,
      email_id: newValue,
      OpportunityTeamRoles: column.id,
      viewType: this.currentviewType,
    })
  }
  private readonly stepValue = 100 / this.PROGRESS_COLUMNS.length

  onCellDropdownChange(element: any, column: any, newValue: string): void {
    const opportunityId = element.opportunityId ?? element.programId ?? null
    const category = column.label
    const colId = column.id
    const oppId = element.opportunityId // or unique row ID

    // Initialize record if needed
    if (!this.completedMap[oppId]) {
      this.completedMap[oppId] = new Set<string>()
    }

    const finals = (this.COMPLETION_MAP[colId] || []).map((v) => v.trim().toLowerCase())
    const value = newValue?.toString().trim().toLowerCase() || ''

    const wasCompleted = this.completedMap[oppId].has(colId)
    const isNowCompleted = finals.includes(value)

    // Progress adjustment logic
    if (!wasCompleted && isNowCompleted) {
      this.completedMap[oppId].add(colId)
    } else if (wasCompleted && !isNowCompleted) {
      this.completedMap[oppId].delete(colId)
    }

    // Save the dropdown change normally
    element[colId].value = newValue
    this.cd.detectChanges()
    // Trigger your existing save/update logic
    this.updateColumnValue.emit({
      opportunityId,
      category,
      newValue,
      viewType: this.currentviewType,
    })
  }
  getSortedReferences(column: any, element: any) {
    const refs = column.references || []
    const selectedValues = element[column.id]?.value || []

    // Move selected emails to top
    return [...refs].sort((a: any, b: any) => {
      const aSelected = selectedValues.includes(a.value)
      const bSelected = selectedValues.includes(b.value)

      if (aSelected && !bSelected) return -1
      if (!aSelected && bSelected) return 1
      return a.viewValue.localeCompare(b.viewValue)
    })
  }

  getLatestComment(comments: Comment[]): Comment | null {
    if (!comments || comments.length === 0) return null
    return [...comments].sort(
      (a, b) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime(),
    )[0]
  }

  openCommentDialog(element: any, column: any): void {
    const columnId = column.id
    const existingComments = element[columnId]?.comments || []
    const latestComment = this.getLatestComment(existingComments)
    const latestCommentText = latestComment ? latestComment.text : ''
    const dialogRef = this.dialog.open(CommentDialogComponent, {
      width: '800px',
      data: {
        title: column.label,
        comment: latestCommentText,
      },
    })

    dialogRef.afterClosed().subscribe((result) => {
      if (result !== undefined) {
        if (!element[columnId]) {
          element[columnId] = { value: '', comments: [] }
        }
        const newComment = {
          author: 'Current User',
          authorEmail: '',
          text: result.trim(),
          createdDate: new Date().toISOString(),
        }
        if (!Array.isArray(element[columnId].comments)) {
          element[columnId].comments = []
        }
        this.updateComment.emit({
          opportunityId: element.opportunityId ?? element.programId ?? null,
          category: column.label,
          comment: result ?? '',
          viewType: this.currentviewType,
        })
        this.cd.detectChanges()
      }
    })
  }
  isColumnComplete(columnId: string, element: any): boolean {
    const value = element[columnId]?.value?.toString().trim().toLowerCase() ?? ''
    const allowedFinals = this.COMPLETION_MAP[columnId] || []
    return allowedFinals.includes(value)
  }
  mapApiResponseToTableData(apiData: any[]): any[] {
    return apiData.map((item) => {
      const row: any = {}
      row.opportunityId = item.opportunityId
      row.clientName = { value: item.client ?? '' }
      row.businessUnit = { value: item.businessUnit ?? '' }
      row.programName = { value: item.program ?? '' }
      row.inceptionDate = { value: this.toShortFormat(item.inceptionDate) ?? '' }
      //    Use emails for multi-select fields
      row.accountExecutive = {
        value: item.accountExecutive?.map((ae: any) => ae.email_id) ?? [],
        emails: item.accountExecutive?.map((ae: any) => ae.email_id) ?? [],
      }
      row.support = {
        value: item.support?.map((s: any) => s.email_id) ?? [],
        emails: item.support?.map((s: any) => s.email_id) ?? [],
      }
      row.analytics = {
        value: item.analytics?.map((an: any) => an.email_id) ?? [],
        emails: item.analytics?.map((an: any) => an.email_id) ?? [],
      }
      //    Ensure all other columns exist
      TRACKING_VIEW_COLUMNS.forEach((colDef) => {
        const colId = String(colDef.id)

        if (
          [
            'clientName',
            'programName',
            'businessUnit',
            'accountExecutive',
            'support',
            'analytics',
            'inceptionDate',
          ].includes(colId)
        ) {
          return
        }

        const colData = item.columns?.find(
          (c: any) => c.columnName.replace(/\s+/g, '').toLowerCase() === colId.toLowerCase(),
        )

        // Build date separation for active vs history
        const active: Record<string, string | null> = {}
        const history: Record<string, string | null> = {}

        if (colData) {
          // ACTIVE value
          const activeKey = (colData.value || '').toString().trim().toLowerCase()
          active[activeKey] = colData.updatedDate ?? null

          // HISTORY values
          if (Array.isArray(colData.valueHistory)) {
            colData.valueHistory.forEach((h: any) => {
              const key = (h.value || '').toString().trim().toLowerCase()

              if (key && key !== activeKey) {
                history[key] = h.updatedDate ?? null
              }
            })
          }
        }

        row[colId] = colData
          ? {
              value: colData.value ?? '',
              updatedDate: colData.updatedDate ?? null,
              updatedSource: colData.updatedSource ?? '',
              comments: colData.comments ?? [],
              //  NEW: merged & separated date map
              dateMap: {
                active,
                history,
              },
            }
          : {
              value: '',
              updatedDate: null,
              updatedSource: '',
              comments: [],
              dateMap: { active: {}, history: {} },
            }
      })
      ;['accountExecutive', 'support', 'analytics'].forEach((key) => {
        if (!row[key]) {
          row[key] = { value: [], emails: [] }
        }
      })

      // Compute placement progress
      const completedCount = this.PROGRESS_COLUMNS.filter((colId) => {
        const rawValue = row[colId]?.value ?? ''
        const value = rawValue.toString().trim().toLowerCase()
        const allowedFinals = this.COMPLETION_MAP[colId]?.map((v) => v.trim().toLowerCase()) ?? []
        return allowedFinals.some((finalVal) => value.includes(finalVal))
      }).length
      let percentage = Math.round((completedCount / this.PROGRESS_COLUMNS.length) * 100)
      percentage = Math.round(percentage / 5) * 5 // nearest 5%
      row.placementProgress = { value: percentage }
      return row
    })
  }

  toShortFormat = (date: Date | null): string | null => {
    if (date === null) {
      return null
    }
    const monthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ]
    const date1 = new Date(date)
    if (isNaN(date1.getTime())) {
      return null // Handle invalid date
    }
    const day = String(date1.getDate()).padStart(2, '0')
    const monthIndex = date1.getMonth()
    const monthName = monthNames[monthIndex]
    const year = date1.getFullYear()
    return `${day}-${monthName}-${year}`
  }

  private getDateForItem(columnId: string, element: any, refValue: string): Date | null {
    const key = (refValue ?? '').toString().trim().toLowerCase()
    const activeStr = element?.[columnId]?.dateMap?.active?.[key] as string | undefined
    const historyStr = element?.[columnId]?.dateMap?.history?.[key] as string | undefined

    const s = activeStr ?? historyStr
    if (!s) return null

    const d = new Date(s)
    return isNaN(d.getTime()) ? null : d
  }

  openCalendarOverlay(event: MouseEvent, ref: any, column: any, element: any): void {
    event.stopPropagation()
    this.closeCalendarOverlay()
    const candidateDate = this.getDateForItem(column.id, element, ref.value) // active → else history
    const selectedDate = candidateDate || new Date()
    const isSameDate = (d1: Date, d2: Date) =>
      d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate()
    const dateClass: (date: Date) => string | undefined = (date: Date) => {
      return candidateDate && isSameDate(date, candidateDate)
        ? 'highlighted-calendar-date'
        : undefined
    }
    this.activeCalendarContext = { element, column, ref, selectedDate }
    const target = event.currentTarget as HTMLElement
    const positionStrategy = this.overlay
      .position()
      .flexibleConnectedTo(target)
      .withFlexibleDimensions(false)
      .withPush(true)
      .withPositions([
        { originX: 'center', originY: 'bottom', overlayX: 'center', overlayY: 'top', offsetY: 6 },
      ])

    this.overlayRef = this.overlay.create({
      positionStrategy,
      hasBackdrop: true,
      backdropClass: 'cdk-overlay-transparent-backdrop',
      scrollStrategy: this.overlay.scrollStrategies.reposition(),
      panelClass: 'tracking-calendar-overlay-panel',
    })

    const portal = new TemplatePortal(this.calendarTemplate!, this.viewContainerRef, {
      $implicit: {
        onDateSelected: this.boundCalendarSelect,
        selectedDate,
        dateClass,
      },
    })
    this.overlayRef.attach(portal)
    this.overlayRef.backdropClick().subscribe(() => this.closeCalendarOverlay())
    this.overlayRef.detachments().subscribe(() => this.closeCalendarOverlay())
  }

  calendarDateSelected(date: Date) {
    if (!this.activeCalendarContext) {
      this.closeCalendarOverlay()
      return
    }
    const { element, column, ref } = this.activeCalendarContext
    if (!element[column.id]) element[column.id] = { value: null }
    element[column.id].date = this.formatLocalDate(date)
    element[column.id].value = element[column.id].value ?? element[column.id].value
    element[column.id].date = date?.toISOString() || null

    const newAuditRecord = {
      columnName: column.label,
      value: element[column.id]?.value ?? '', // current dropdown value
      updatedDate: date?.toLocaleString() ?? null,
      updatedSource: 'Manual',
      auditCreatedDate: new Date().toISOString(), // audit timestamp (now)
    }

    // Append to auditColumns
    if (!Array.isArray(element.auditColumns)) {
      element.auditColumns = []
    }
    element.auditColumns.push(newAuditRecord)
    this.updateColumnValue.emit({
      opportunityId: element.opportunityId ?? element.programId ?? null,
      category: column.label,
      newValue: ref.value,
      dateTime: this.formatLocalDate(date),
      viewType: this.currentviewType,
    })
    this.closeCalendarOverlay()
  }

  formatLocalDate(date: Date): string {
    const pad = (n: number) => String(n).padStart(2, '0')
    return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate())
  }

  closeCalendarOverlay() {
    this.activeCalendarContext = null
    if (this.overlayRef) {
      try {
        this.overlayRef.dispose()
      } catch (e) {
        /* ignore */
      }
      this.overlayRef = null
    }
  }
  canEdit(): boolean {
    if (this.currentviewType === 'client view') {
      return false
    }
    return true
  }

  togglePin(columnId: string, event: MouseEvent): void {
    event.stopPropagation()
    // Only allow pinning clientName, programName, placementProgress
    if (
      columnId !== 'clientName' &&
      columnId !== 'programName' &&
      columnId !== 'placementProgress'
    ) {
      return
    }
    if (this.pinnedColumns.has(columnId)) {
      this.pinnedColumns.delete(columnId)
    } else {
      this.pinnedColumns.add(columnId)
    }
  }

  onDropdownOpened(open: boolean, select: MatSelect, column: any, element: any) {
    // close: clean up and bail
    if (!open) {
      this.searchSub?.unsubscribe()
      this.searchSub = undefined
      return
    }

    // open: wait for overlay panel to mount
    setTimeout(() => {
      const overlay = this.overlayContainer.getContainerElement()
      const panels = overlay.querySelectorAll('.mat-mdc-select-panel')
      const panel = panels[panels.length - 1] as HTMLElement
      if (!panel) return

      // remove any prior search box if reopen
      panel.querySelector('.custom-search-box')?.remove()

      panels.forEach((panel) => {
        panel.setAttribute('style', 'padding-top: 0')
      })

      const searchBox = document.createElement('input')
      searchBox.type = 'text'
      searchBox.placeholder = 'Search...'
      searchBox.classList.add('custom-search-box')
      searchBox.style.cssText = `
      width: calc(100%);
      padding: var(--stack);
      border-bottom: 1px solid var(--border);
      border-right: 0;
      background: var(--bg-1);
      color: white;
      outline: none;
      position: sticky;
      top: 0;
      z-index: 100;
      box-sizing: border-box;
    `
      panel.prepend(searchBox)

      const filterKey = column.id + '_' + element.opportunityId
      const original = this.getSortedReferences(column, element)
      this.filteredOptions[filterKey] = [...original]

      const normalize = (s: string) => s.toLowerCase().replace(/\s+/g, ' ').trim()

      this.searchSub?.unsubscribe()
      this.searchSub = fromEvent(searchBox, 'input').subscribe((e: any) => {
        const val = e.target.value || ''
        this.ngZone.run(() => {
          this.filteredOptions[filterKey] = !val
            ? [...original]
            : original.filter((opt) => normalize(opt.viewValue).includes(normalize(val)))
        })
      })

      setTimeout(() => searchBox.focus(), 50)
    }, 150)
  }
}
